<script setup lang="ts">
defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
  context: {
    type: [Object, Array],
    default: () => null,
  },
})
</script>

<template>
  <StrapiSlice
    v-if="slice?.EmbedCode"
    class="ct-embed"
    :slice="slice"
    :index="index"
  >
    <UiEmbed :embed-code="slice.EmbedCode" />
  </StrapiSlice>
</template>

<style>
@import url("~layers/app/components/Slices/Embed.css");
</style>
